import { Routes, Route } from 'react-router';
import { lazy, Suspense } from 'react';
import { LazyErrorBoundary, EnhancedPageLoader } from './utils/lazyLoading';

// Lazy load all pages
const Home = lazy(() => import('@pages/Home'));
const Chat = lazy(() => import('@pages/Chat'));
const NotFound = lazy(() => import('@pages/NotFound'));
const PodusDocumentPage = lazy(() => import('@pages/Document'));

// loading fallback
function PageLoader() {
    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-background backdrop-blur-sm">
            <div className="flex items-center space-x-3">
                <div className="w-8 h-8 border-3 border-secondary border-t-transparent rounded-full animate-spin"></div>
                <span className="text-secondary font-medium">Loading page...</span>
            </div>
        </div>
    );
}

export default function AppRoutes() {
    return (
        <LazyErrorBoundary fallback={<EnhancedPageLoader />}>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route index element={<Home />} />
                    <Route path="/c/:chatId" element={<Chat />} />
                    <Route path="/public/document/:documentId" element={<PodusDocumentPage />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        </LazyErrorBoundary>
    );
}
